import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import {
    Card,
    CardContent,
    CardHeader,
    Container,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TablePagination,
    TableRow,
} from '@mui/material';
import { ThreeDots } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
// components
import Scrollbar from '../../../components/scrollbar';
// sections
import { UserListHead } from '../../../sections/@dashboard/user';

import { Page } from '../../../components';
import { getProfile } from '../../../shared/auth/authService';
import { fCurrency } from '../../../utils/formatNumber';
import { fDateTime } from '../../../utils/formatTime';
import { Accept, Decline, NewDisposal } from '../components';
import { getDisposals } from '../store/disposalActions';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'assetID', label: 'Asset ID', alignRight: false },
  { id: 'asset', label: 'Asset', alignRight: false },
  { id: 'barcodeNumber', label: 'Barcode Number', alignRight: false },
  { id: 'branch', label: 'Branch', alignRight: false },
  // { id: 'requestedBy', label: 'Requested By', alignRight: false },
  // { id: 'customerName', label: 'Customer Name', alignRight: false },
  // { id: 'customerPhone', label: 'Customer Phone', alignRight: false },
  { id: 'estimateAmount', label: 'Amount', alignRight: false },
  { id: 'date', label: 'Date', alignRight: false },
  // { id: 'status', label: 'Status', alignRight: false },
  // { id: '' },
];
// ----------------------------------------------------------------------
const storedUser = JSON.parse(localStorage.getItem('profile'));

const branchRoles = ['MANAGER', 'BRANCH_MANAGER'];

const isManager = storedUser?.role && branchRoles.includes(storedUser.role);

export default function Disposals() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, disposals, pagination } = useSelector((state) => state.disposalReducer);
  //

  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [user, setUser] = useState({});
  const [open, setOpen] = useState(false);
  const [openDisposal, setOpenDisposal] = useState(false);
  const [openAccept, setOpenAccept] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const handleClose = () => {
    setOpen(!open);
    setTimeout(() => {
      const payload = {
        page: page + 1,
        rowsPerPage,
      };
      dispatch(getDisposals(payload));
    }, 2000); // 2000 mil
  };
  const handleOpenDisposal = () => {
    setOpenDisposal(!openDisposal);
    setTimeout(() => {
      const payload = {
        page: page + 1,
        rowsPerPage,
      };
      dispatch(getDisposals(payload));
    }, 2000); // 2000 mil
  };

  const handleCloseAccept = () => {
    setOpenAccept(!openAccept);
    setTimeout(() => {
      const payload = {
        page: page + 1,
        rowsPerPage,
      };
      dispatch(getDisposals(payload));
    }, 2000); // 2000 mil
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const payload = {
      page: page + 1,
      rowsPerPage,
    };
    dispatch(getDisposals(payload));
  }, [dispatch, page, rowsPerPage]);

  useEffect(() => {
    const profile = getProfile();
    if (profile) {
      setUser(profile);
    }
  }, []);

  return (
    <>
      <Page title="Disposals">
        {openDisposal && <NewDisposal open={openDisposal} handleClose={handleOpenDisposal} />}
        {openAccept && <Accept open={openAccept} handleClose={handleCloseAccept} disposalId={selectedRow?.id} />}
        {open && <Decline open={open} handleClose={handleClose} disposalId={selectedRow?.id} />}
        <Container maxWidth="xl">
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Card>
                {/* {isManager && (
                  <Box sx={{ p: 2 }}>
                    <Stack direction="row" sx={{ float: 'right' }} spacing={0.5}>
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => setOpenHandover(true)}
                        startIcon={<Iconify icon="eva:plus-fill" />}
                      >
                        New Handover
                      </Button>
                    </Stack>
                  </Box>
                )} */}
                <CardHeader title={'Disposals'} subheader={''} />
                <CardContent>
                  <Scrollbar>
                    <TableContainer sx={{ minWidth: 800 }} component={Paper}>
                      {isLoading ? (
                        <Grid container sx={{ justifyContent: 'center' }}>
                          <ThreeDots
                            height="80"
                            width="80"
                            radius="9"
                            color="#2065d1"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{}}
                            wrapperClassName=""
                            visible
                          />
                        </Grid>
                      ) : (
                        <Table size="small">
                          <UserListHead headLabel={TABLE_HEAD} rowCount={disposals?.length} />
                          <TableBody>
                            {disposals?.length > 0 ? (
                              disposals.map((record) => (
                                <TableRow hover key={record?.id} tabIndex={-1} role="checkbox">
                                  <TableCell align="left">{record?.asset_tag}</TableCell>
                                  <TableCell align="left">{record?.name}</TableCell>
                                  <TableCell align="left">{record?.barcode_number}</TableCell>
                                  <TableCell align="left">{record?.location?.name}</TableCell>
                                  {/* <TableCell align="left">{record?.staff?.user?.display_name}</TableCell>
                                  <TableCell align="left">{record?.customer_name}</TableCell>
                                  <TableCell align="left">{record?.mobile_number}</TableCell> */}
                                  <TableCell align="left">{fCurrency(record?.purchase_cost)}</TableCell>
                                  <TableCell align="left">{fDateTime(record?.date_created)}</TableCell>

                                  {/* <TableCell align="left">
                                    <Label
                                      color={
                                        (record?.status === 'PENDING' && 'warning') ||
                                        (record?.status === 'REJECTED' && 'error') ||
                                        'success'
                                      }
                                    >
                                      {sentenceCase(record?.status)}
                                    </Label>
                                  </TableCell>
                                  <TableCell>
                                    <Stack spacing={2} direction="row">
                                      {user?.role === 'ADMIN' && record?.status === 'PENDING' && (
                                        <>
                                          <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={() => {
                                              setSelectedRow(record);
                                              setOpenAccept(true);
                                            }}
                                          >
                                            Approve
                                          </Button>
                                          <Button
                                            size="small"
                                            variant="outlined"
                                            color="error"
                                            onClick={() => {
                                              setSelectedRow(record);
                                              setOpen(true);
                                            }}
                                          >
                                            Reject
                                          </Button>
                                        </>
                                      )}

                                      <Button
                                        size="small"
                                        variant="contained"
                                        onClick={() => navigate(`/dashboard/handovers/${record?.id}`)}
                                      >
                                        View
                                      </Button>
                                    </Stack>
                                  </TableCell> */}
                                </TableRow>
                              ))
                            ) : (
                              <>Disposal requests will appear here</>
                            )}
                          </TableBody>
                        </Table>
                      )}
                    </TableContainer>
                  </Scrollbar>

                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    component="div"
                    count={pagination?.count || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Page>
    </>
  );
}
